export default __webpack_public_path__ + "images/certificate-seal-light.svg";